import {vec3} from "_src/libs/gl-matrix";

export default class {

  constructor() {
    this.point  = null;
    this.normal = null;
    this.selector = null;
  }

  apply() {
    this.selector.applyHistoryToPlane(this.point, this.normal);
  }

  appendData(selector, point, normal) {
    this.selector = selector;
    this.point = point ? vec3.clone(point) : null;
    this.normal = normal ? vec3.clone(normal) : null;
  }

}
